module.exports = __webpack_public_path__ + "04805e31168789811018a02405b03bea.svg";